module.exports = __webpack_public_path__ + "static/media/gallery-2.2150e096.jpg";